module.exports = __webpack_public_path__ + "static/media/success.363b9209.png";